export default __webpack_public_path__ + "static/media/sidebar-n.f021d3d4.jpg";